<p style="display: flex; align-items: center">
  <textarea #arField type="text" class="form-control input-st input-st-keyboardAr" id="lnameControlAr" [disabled]="_disabled" style="direction: rtl" [(ngModel)]="field" (change)="removeWspace()" (keypress)="allowOnlyArabic($event)" (paste)="onPasteArabic($event)"></textarea>
</p>
